function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { injectExternalScript, injectExternalStylesheet } from './injector';
import './index';

var AtresWidgetController = /*#__PURE__*/function () {
  _createClass(AtresWidgetController, null, [{
    key: "registerWidgetType",
    value: function registerWidgetType(typeFn) {
      AtresWidgetController.registerWidgetType = typeFn;
    }
  }]);

  function AtresWidgetController(targetElement, widgetsChange) {
    var _this = this;

    _classCallCheck(this, AtresWidgetController);

    _defineProperty(this, "createInitialWidgets", function () {
      var widgets = _toConsumableArray(document.querySelectorAll('atres-widget'));

      widgets.forEach(function (w) {
        _this.createWidget({
          target: w
        });
      });
    });

    _defineProperty(this, "createWidget", function (event) {
      event.stopPropagation && event.stopPropagation();
      var widget = event.target; // widget.innerHTML = "";
      // Nos quedamos solo con los widgets que estan en el DOM

      _this.activeWidgets = _this.activeWidgets.filter(function (e) {
        return e.isConnected;
      });

      _this.activeWidgets.push(widget); // Unregister widget when unmount


      _this.element.addEventListener('widgetDidUnmount', function (event) {
        event.stopPropagation();
        var widget = event.target;
        console.log("widget: ".concat(widget.id, " "), 'unmounted!'); // widget.removeEventListeners();

        _this.activeWidgets = _this.activeWidgets.filter(function (e) {
          return e.id !== widget.id;
        });
        _this.widgetsChange && _this.widgetsChange(_this.activeWidgets);
      });

      _this.initializeWidget(widget);
    });

    this.activeWidgets = [];
    this.element = targetElement;
    this.widgetsChange = widgetsChange;
    this.element.addEventListener('widgetDidMount', this.createWidget); //Si ya habia widgets en el DOM hay que renderizarlos

    if (document.readyState !== 'loading') {
      this.createInitialWidgets();
    } else {
      document.addEventListener('DOMContentLoaded', function (event) {
        _this.createInitialWidgets();
      });
    }
  }

  _createClass(AtresWidgetController, [{
    key: "initializeWidget",
    value: function initializeWidget(widget) {
      var _this2 = this;

      var externalSrc = widget.getAttribute('data-src');
      var externalStyles = widget.getAttribute('data-stylesheet');
      var widgetType = widget.getAttribute('data-type');
      Promise.resolve(externalSrc && injectExternalScript(externalSrc)).then(externalStyles && injectExternalStylesheet(externalStyles)).then(function () {
        var renderer = AtresWidgetController.registeredWidgetTypes[widgetType];
        if (renderer) renderer(widget, _this2.element);
        console.log("widget: ".concat(widget.id, " "), 'mounted!');
        if (_this2.widgetsChange) _this2.widgetsChange(_this2.activeWidgets);
      });
    }
  }]);

  return AtresWidgetController;
}();

_defineProperty(AtresWidgetController, "registeredWidgetTypes", {});

export { AtresWidgetController as default };